import { useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TUserStackParamList } from '../types';

type SupportNavigationProp = NativeStackNavigationProp<TUserStackParamList>;

export const useSupportContent = () => {
  const navigation = useNavigation<SupportNavigationProp>();
  const navigationHandlers = useMemo(() => ({
    handleHelp: () => navigation.navigate('FAQ'),
  }), [navigation]);

  return {
    navigationHandlers,
  };
};
